<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form ref="Form">
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.unidades"
                            @change="handleUnidadeChange"
                            default-option-text="Todas"
                            label="Unidade"
                            show-default-option
                            text-field="nomeFantasia"
                            v-model="model.unidadeId"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-select
                            :options="form.infraestruturas"
                            default-option-text="Todos"
                            label="Local de atendimento"
                            show-default-option
                            text-field="nome"
                            v-model="model.infraestruturaId"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <rkm-button
                            @click="search"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button @click="reset">
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="items.length > 0">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-dropdown
                        class="mr-2"
                        color="primary"
                        cols="1"
                        menu-class="auto-scroll"
                        no-caret
                        small
                        title="Colunas"
                        v-rkm-tooltip.hover
                    >
                        <template v-slot:button-content>
                            <rkm-icon icon="columns" />
                        </template>

                        <rkm-form-checkbox
                            :indeterminate="indeterminate"
                            @change="selectAll"
                            class="mx-2"
                            v-model="selectedAll"
                        >
                            Todas
                        </rkm-form-checkbox>

                        <rkm-form-checkbox-group
                            :options="optionalColumns"
                            class="mx-2"
                            stacked
                            text-field="label"
                            v-model="selectedCols"
                            value-field="key"
                        />
                    </rkm-dropdown>

                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="columns"
                    :items="items"
                    per-page="100"
                />
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        columns() {
            return this.fields.filter(c => (c.fixed || false) || this.selectedCols.includes(c.key))
        },
        optionalColumns() {
            return this.fields.filter(field => !(field.fixed || false))
        },
    },
    created() {
        this.repositories = {
            impressao: this.getConectaSusRepository('impressao.imunizacao'),
            relatorioPosicaoEstoque: this.getConectaSusRepository('imunizacao.relatorioPosicaoEstoque'),
        }

        this.load()
    },
    data() {
        return {
            form: null,
            fields: [
                {fixed: true, key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
                {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
                {fixed: true, key: 'vacina', label: 'Vacina', sortable: true},
                {key: 'produtorNome', label: 'Produtor', sortable: true},
                {key: 'apresentacaoNome', label: 'Apresentação', sortable: true},
                {fixed: true, key: 'entradaVacinaLote', label: 'Lote', sortable: true},
                {fixed: true, key: 'entradaVacinaDataValidadeLote', label: 'Data de validade do lote', sortable: true},
                {fixed: true, key: 'estoque', label: 'Estoque', sortable: true},
            ],
            indeterminate: true,
            items: [],
            model: null,
            selectedAll: false,
            selectedCols: [],
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioPosicaoEstoque.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
            }

            this.setLoading()

            this.repositories.relatorioPosicaoEstoque.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.items = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.form.unidades = []
            this.form.infraestruturas = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.items = []
        },
        print() {
            this.setLoading()

            const request = {
                unidadeId: this.model.unidadeId,
                infraestruturaId: this.model.infraestruturaId,
                selectedCols: this.columns.filter(column => column.key !== 'actions').map(column => ({
                    class: column.class,
                    key: this.camelToSnake(column.key),
                    label: column.label,
                }))
            }

            this.repositories.impressao.relatorioPosicaoEstoque(this.camelObjectKeysToSnakeRecursive(request))
                .then(({data, headers}) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handleUnidadeChange(value) {
            this.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) {
                return
            }

            const request = {
                listar: 'infraestruturas',
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.relatorioPosicaoEstoque.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.infraestruturas = Object.assign(response.data.infraestruturas))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        selectAll(selected) {
            this.selectedCols = selected ? this.optionalColumns.map(c => c.key) : []
        },
    },
    mixins: [error, file, repository, stringCase],
}
</script>